import React from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import swal from "sweetalert";
import ReactPaginate from "react-paginate";
import { getCookie } from "../../inc/cookies";
import config from "../../inc/config";
import { formatPlate, isoToDateTime } from "../../inc/helper";

import Select from 'react-select';
import AuctionCommentModal from "../../component/auctiom/AuctionCommentModal";

class AuctionVehiclesModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,

      auctionVehicles: [],
      vehicleBrands: [],
      vehicleModels: [],
      vehicleModelYears: [],
      vehicleEquipments: [],

      vehicleBrandId: 0,
      vehicleModelId: 0,
      vehicleEquipmentId: 0,

      filterId: '',
      filterTitle: '',
      filterVehicleBrandId: '',
      filterVehicleModelId: '',
      filterVehicleEquipmentId: '',
      filterYear: '',
      filterSoldStatus: '',
      filterActive: '',
      filterNotAuctionId: '',

      isOpenCommentModal: false,
      comment: '',

      pageCount: 0,
      resultCount: 0,
      currentPage: 1,
      limit: 10,
    };
  }

  componentDidMount() {
    const searchParams = new URLSearchParams(window.location.search);
    const currentPage = parseInt(searchParams.get("page")) || 1;
  
    this.setState({
      currentPage,
      filterId: searchParams.get("filterId") || '',
      filterTitle: searchParams.get("filterTitle") || '',
      filterVehicleBrandId: searchParams.get("filterVehicleBrandId") || '',
      filterVehicleModelId: searchParams.get("filterVehicleModelId") || '',
      filterVehicleEquipmentId: searchParams.get("filterVehicleEquipmentId") || '',
      filterYear: searchParams.get("filterYear") || '',
      filterSoldStatus: searchParams.get("filterSoldStatus") || '',
      filterActive: searchParams.get("filterActive") || '',
      filterNotAuctionId: searchParams.get("filterNotAuctionId") || '',
    }, () => {
      this.getAuctionVehicles(this.state.currentPage);
      if (!this.props.searchParams.get('filterVehicleBrandId')) {
        this.getAuctionVehicleBrands();
      } else{
        this.getBrand();
      }
    });
  
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {}

  getBrand() {
    let sessionHash = getCookie('sessionHash');
    this.setState({ isLoading: true });
  
    const requestOptions = {
      method: 'GET',
      headers: { 'Authorization': 'Bearer ' + sessionHash }
    };
  
    let errorMessages = [];

    // Marka listesi çekiliyor
    fetch(config.restApi + 'vehicleBrands/tr?limit=1000', requestOptions)
      .then(res => res.json())
      .then(brandData => {
        if (brandData.status === 200) {
          this.setState({ vehicleBrands: brandData.vehicleBrands });
        } else {
          errorMessages.push(brandData.message);
        }

        if (this.props.searchParams.get('filterVehicleBrandId')) {
          // Model listesi çekiliyor
          fetch(config.restApi + 'vehicleModels/tr/' + this.props.searchParams.get('filterVehicleBrandId') + '?limit=1000', requestOptions)
          .then(res => res.json())
          .then(modelData => {
            if (modelData.status === 200) {
              this.setState({
                vehicleModels: modelData.vehicleModels
              });
            } else {
              errorMessages.push(modelData.message);
            }

            if (this.props.searchParams.get('filterVehicleModelId')) {
              // Model listesi çekiliyor
              fetch(config.restApi + 'vehicleModelYears/tr/' + this.props.searchParams.get('filterVehicleModelId') + '?limit=1000', requestOptions)
              .then(res => res.json())
              .then(modelData => {
                if (modelData.status === 200) {
                  this.setState({
                    vehicleModelYears: modelData.vehicleModelYears
                  });
                } else {
                  errorMessages.push(modelData.message);
                }

                if (this.props.searchParams.get('filterYear')) {
                  // Variant listesi çekiliyor
                  fetch(config.restApi + 'vehicleEquipments/tr/' + this.props.searchParams.get('filterVehicleModelId') + '/' + this.props.searchParams.get('filterYear') + '?limit=1000', requestOptions)
                  .then(res => res.json())
                  .then(variantData => {
                    if (variantData.status === 200) {
                      this.setState({
                        vehicleEquipments: variantData.vehicleEquipments
                      });
                    } else {
                      errorMessages.push(variantData.message);
                    }

                    // Tüm işlemler tamamlandı
                    this.setState({ isLoading: false });
                    if (errorMessages.length > 0) {
                      swal({
                        dangerMode: true,
                        icon: 'warning',
                        title: 'Hay Aksi',
                        text: errorMessages[0],
                        buttons: 'Tamam'
                      }).then(() => this.props.navigate('/home'));
                    }
                  }).catch(() => {
                    errorMessages.push('Lütfen internet bağlantınızı kontrol ediniz.');
                    this.setState({ isLoading: false });
                  });
                }
                }).catch(() => {
                errorMessages.push('Lütfen internet bağlantınızı kontrol ediniz.');
                this.setState({ isLoading: false });
              }); 
            }
          }).catch(() => {
            errorMessages.push('Lütfen internet bağlantınızı kontrol ediniz.');
            this.setState({ isLoading: false });
          }); 
        }
      }).catch(() => {
        errorMessages.push('Lütfen internet bağlantınızı kontrol ediniz.');
        this.setState({ isLoading: false });
      });
  
    window.scrollTo(0, 0);
  }

  getAuctionVehicles(currentPage) {
    const { filterId, filterTitle, limit, filterVehicleBrandId, filterVehicleModelId, filterVehicleEquipmentId, filterYear, filterSoldStatus, filterActive, filterNotAuctionId } = this.state;
  
    let sessionHash = getCookie("sessionHash");

    this.setState({isLoading: true});

    const requestOptions = {
      method: "GET",
      headers: { Authorization: "Bearer " + sessionHash },
    };
  
    let query = `limit=${limit}&page=${currentPage}`;
    if (filterId) query += `&filterId=${filterId}`;
    if (filterTitle) query += `&filterTitle=${encodeURIComponent(filterTitle)}`;
    if (filterVehicleBrandId) query += `&filterVehicleBrandId=${filterVehicleBrandId}`;
    if (filterVehicleModelId) query += `&filterVehicleModelId=${filterVehicleModelId}`;
    if (filterVehicleEquipmentId) query += `&filterVehicleEquipmentId=${filterVehicleEquipmentId}`;
    if (filterYear) query += `&filterYear=${filterYear}`;
    if (filterSoldStatus) query += `&filterSoldStatus=${filterSoldStatus}`;
    if (filterActive) query += `&filterActive=${filterActive}`;
    if (filterNotAuctionId) query += `&filterNotAuctionId=${filterNotAuctionId}`;
  
    fetch(`${config.restApi}auctionVehicles/tr?${query}`, requestOptions)
      .then((response) => response.json())
      .then((responseData) => {
        switch (responseData.status) {
          case 200:
            this.setState({isLoading: false, auctionVehicles: responseData.auctionVehicles, pageCount: responseData.pageCount, resultCount: responseData.resultCount, currentPage});
            break;
            case 401:
              swal({
                dangerMode: true,
                icon: 'warning',
                title: 'Hay Aksi',
                text: responseData.message,
                buttons: 'Tamam'
              }).then(this.props.navigate('/home'))
            break;
            default:
              swal({
                dangerMode: true,
                icon: "warning",
                title: "Hay Aksi",
                text: responseData.message,
                buttons: "Tamam",
              }).then(this.setState({isLoading: false}));
              break;
          }
        },
        () =>
          swal({
            dangerMode: true,
            icon: "error",
            title: "Bağlantı Hatası",
            text: "Lütfen internet bağlantınızı kontrol ediniz.",
            buttons: "Tamam",
          })
      );
  }

  getAuctionVehicleBrands() {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'vehicleBrands/tr?limit=1000', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200:
          this.setState({isLoading: false, vehicleBrands: responseData.vehicleBrands})
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default:
          this.setState({isLoading: false});

          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        break;
      }
    }, () =>swal({ dangerMode: true, icon: "error", title: "Bağlantı Hatası", text: "Lütfen internet bağlantınızı kontrol ediniz.", buttons: "Yeniden Dene",}).then(() => this.getMyAppointmentsDetail()));
  }

  getModels(vehicleBrandId) {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'vehicleModels/tr/' + vehicleBrandId + '?limit=1000', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({vehicleBrandId: vehicleBrandId, vehicleModelId: '', vehicleModels: responseData.vehicleModels});
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  getYears(vehicleModelId) {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'vehicleModelYears/tr/' + vehicleModelId + '?limit=1000', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({vehicleModelId: vehicleModelId, vehicleModelYears: responseData.vehicleModelYears});
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }
  
  getVehicleEquipments(vehicleModelId, year) {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'vehicleEquipments/tr/' + vehicleModelId + '/' + year + '?limit=1000', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({vehicleModelId: vehicleModelId, vehicleEquipments: responseData.vehicleEquipments});
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  deleteAuctionVehicleOnClick(id) {
    swal({
      dangerMode: true,
      icon: 'warning',
      title: 'Onayla',
      text: 'Aracı sistemden silmek istediğinize emin misiniz?',
      buttons: {confirm: 'Tamam', cancel: 'Vazgeç'}
    }).then(value => {
      if (value) {
        let sessionHash = getCookie('sessionHash');

        const requestOptions = {
          method: 'DELETE',
          headers: {'Authorization': 'Bearer ' + sessionHash}
        };

        fetch(config.restApi + 'auctionVehicle/tr/' + id, requestOptions)
        .then(response => response.json())
        .then(responseData => {
          switch (responseData.status) {
            case 200: {
              swal({
                dangerMode: true,
                icon: 'success',
                title: 'Tamamlandı',
                text: 'Araç sistemden başarıyla silindi.',
                buttons: 'Tamam'
              }).then(() =>  this.getAuctionVehicles(this.state.currentPage));
            }
            break;
            default: {
              swal({
                dangerMode: true,
                icon: 'warning',
                title: 'Hay Aksi',
                text: responseData.message,
                buttons: 'Tamam'
              });
            }
            break;
          }
        }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
      }
    });
  }

  selectedBrandOnChange = (selectedBrand) => {
    const vehicleBrandId = selectedBrand ? selectedBrand.value : '';
    if (vehicleBrandId) {
      this.getModels(vehicleBrandId);
    } else {
      this.setState({ filterVehicleBrandId: '', filterYear: '', filterVehicleModelId: '', vehicleModels: [], vehicleModelYears: [], vehicleEquipments: [] });
      return;
    }
  
    this.setState({ filterVehicleBrandId: vehicleBrandId, filterYear: '', filterVehicleModelId: '', filterVehicleEquipmentId: '', vehicleModelYears: [], vehicleEquipments: [] });
  };
  
  selectedModelOnChange = (selectedModel) => {
    const vehicleModelId = selectedModel ? selectedModel.value : '';

    if (vehicleModelId) {
      this.getYears(vehicleModelId);
    } else {
      this.setState({ filterVehicleModelId: '', filterYear: '', filterVehicleEquipmentId: '', vehicleModelYears: [], vehicleEquipments: [] });
      return;
    }

    this.setState({ filterVehicleModelId: vehicleModelId, filterYear: '', filterVehicleEquipmentId: '', vehicleEquipments: [] });
  };

  selectedYearOnChange = (selectedYear) => {

    const year = selectedYear ? selectedYear.search : ''

    if (year) {
      this.getVehicleEquipments(this.state.filterVehicleModelId, year);
    } else {
      this.setState({ filterYear: '', filterVehicleEquipmentId: '', vehicleEquipments: []});
      return;
    }

    this.setState({ filterYear: parseInt(year), filterVehicleEquipmentId: '' });
  }

  selectedVariantOnChange = (selectedVariant) => {
    const vehicleEquipmentId = selectedVariant ? selectedVariant.value : '';
    this.setState({ filterVehicleEquipmentId: vehicleEquipmentId });
  };

  handlePageClick(page) {
    // URL parametrelerini güncellemek için URLSearchParams kullanıyoruz
    const params = new URLSearchParams(window.location.search);
  
    // Mevcut sayfa parametresini güncelliyoruz
    params.set('page', page.selected + 1);  // sayfa numarası 0-indexed olduğu için +1 ekliyoruz
  
    // Yeni URL'yi oluşturuyoruz
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    
    // URL'yi güncelliyoruz (browser history'yi de değiştiriyoruz, sayfa yenilenmeden)
    window.history.pushState(null, '', newUrl);
    
    this.setState({ currentPage: page.selected + 1 }, () => {this.getAuctionVehicles(this.state.currentPage);});
  }

  filterOnClick = () => {
    const params = new URLSearchParams();
  
    if (this.state.currentPage) params.append('page', 1);
    if (this.state.filterId) params.append('filterId', this.state.filterId);
    if (this.state.filterTitle) params.append('filterTitle', this.state.filterTitle);
    if (this.state.filterVehicleBrandId) params.append('filterVehicleBrandId', this.state.filterVehicleBrandId);
    if (this.state.filterVehicleModelId) params.append('filterVehicleModelId', this.state.filterVehicleModelId);
    if (this.state.filterVehicleEquipmentId) params.append('filterVehicleEquipmentId', this.state.filterVehicleEquipmentId);
    if (this.state.filterYear) params.append('filterYear', this.state.filterYear);
    if (this.state.filterSoldStatus) params.append('filterSoldStatus', this.state.filterSoldStatus);
    if (this.state.filterActive) params.append('filterActive', this.state.filterActive);
    if (this.state.filterNotAuctionId) params.append('filterNotAuctionId', this.state.filterNotAuctionId);
  
    const queryString = params.toString();
    this.props.navigate(`?${queryString}`);
  
    this.getAuctionVehicles(1); // Sayfa 1'den başla
  };
  
  resetOnClick = () => {
    this.setState({
      filterId: '',
      filterTitle: '',
      filterVehicleBrandId: '',
      filterVehicleModelId: '',
      filterVehicleEquipmentId: '',
      filterYear: '',
      filterSoldStatus: '',
      filterActive: '',
      filterNotAuctionId: '',
      currentPage: 1,
      vehicleModels: [],
      vehicleModelYears: [],
      vehicleEquipments: []
    }, () => {
      this.getAuctionVehicles(1); // Sayfa 1'den başla
  
      // URL'deki tüm parametreleri kaldır
      this.props.navigate('?'); // URL'yi temizle
    });
  };
  
  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.filterOnClick();
    }
  };

  render() {

    const selectedBrandsOptions = [
      {value: '', label: 'Seçiniz' }, ...this.state.vehicleBrands.map((brandInfo) => ({
        value: brandInfo.id,
        label: `${brandInfo.name}`,
        search: brandInfo.name
      }))
    ];

    const selectedModelsOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.vehicleModels.map((modelInfo) => ({
        value: modelInfo.id,
        label: `${modelInfo.name}`,
        search: modelInfo.name
      }))
    ];

    const selectedYearsOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.vehicleModelYears.map((yearInfo) => ({
        value: yearInfo.year,
        label: `${yearInfo.year}`,
        search: yearInfo.year
      }))
    ];

    const selectedVariantsOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.vehicleEquipments.map((variantInfo) => ({
        value: variantInfo.id,
        label: `${variantInfo.name}`,
        search: variantInfo.name
      }))
    ];

    return this.state.isLoading ? (
      <div className="ibox-content sk-loading position-static">
        <div className="sk-spinner sk-spinner-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
        </div>
      </div>
    ) : (
      <div className="row custom-container">
        <div className="col-xl-9">
          <div className="ibox">
            <div className="ibox-title d-flex justify-content-between pr-3">
              <strong className="text-black">Araçlar</strong>
              <Link className="btn btn-orange" title="Araç Ekle" to={'/auctionVehicleAdd'}><i className="fa fa-plus"></i></Link>
            </div>
            <div className="table-responsive-lg mb-5">
              <table className="table table-bordered text-center">
                <thead>
                  <tr className="text-black">
                    <th>Araç Başlığı</th>
                    <th>Araç Markası</th>
                    <th>Açıklama</th>
                    <th>Eklenme Tarihi</th>
                    <th>Düzenlenme Tarihi</th>
                    <th>Detay</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.auctionVehicles.map((auctionVehicle, index) =>
                    <tr key={index}>
                      <td className="align-middle">{auctionVehicle.title}<br />Araç No #:<b>{auctionVehicle.id}</b></td>
                      <td className="align-middle">Plaka:<br /><b>{formatPlate(auctionVehicle?.details?.plateNumber)}</b> <br /><br /> {auctionVehicle.vehicleBrandName} - {auctionVehicle.vehicleModelName} <br />{auctionVehicle.vehicleEquipmentName} {auctionVehicle.year > 0 && "- " + auctionVehicle.year}</td>
                      <td className="align-middle" style={{maxWidth:1000}}><button className="btn btn-orange" title="Açıklama" onClick={() => this.setState({comment: auctionVehicle.comment, isOpenCommentModal: true})}><i className="fa fa-eye"></i></button></td>
                      <td className="align-middle">{isoToDateTime(auctionVehicle.addedDate)}</td>
                      <td className="align-middle">{isoToDateTime(auctionVehicle.modifiedDate)}</td>
                      <td className="align-middle" style={{minWidth:98.5}}>
                        <Link className="btn btn-orange m-1" title="Düzenle" to={`/auctionVehicleEdit?id=${auctionVehicle.id}`}><i className="fa fa-pencil"></i></Link>
                        <button className="btn btn-orange m-1" title="Sil" onClick={() => this.deleteAuctionVehicleOnClick(auctionVehicle.id)}><i className="fa fa-trash"></i></button>
                        <Link className="btn btn-darkblue m-1" title="Araç Detay" to={"/auctionVehicleDetail?id=" + auctionVehicle.id}><i className="fa fa-eye"></i></Link>
                      </td>
                    </tr>
                  )}
                  {this.state.auctionVehicles.length === 0 && <tr><td className="align-middle text-darkblue p-3" colSpan="6">Araç Bulunamadı !</td></tr>}
                </tbody>
              </table>
            </div>
            {this.state.auctionVehicles.length !== 0 &&
            <ReactPaginate
              previousLabel={"Geri"}
              nextLabel={"İleri"}
              breakLabel={"..."}  
              pageCount={this.state.pageCount}
              marginPagesDisplayed={1}
              onPageChange={page => this.handlePageClick(page)}
              pageRangeDisplayed={10}
              containerClassName={'pagination'}
              activeClassName={'activePage'}
              forcePage={Number(this.state.currentPage) - 1}
            />
            }
          </div>
        </div>
        <div className="col-xl-3 order-first order-xl-last d-xl-none" id="accordion">
          <div className="ibox">
            <div className="ibox-content text-darkblue p-0">
              <h4 className="collapse-title">
                <a className="btn btn-link text-darkblue font-bold d-flex justify-content-between" data-toggle="collapse" href="#filterCollapse" title="Filtrele">Filtrele</a>
              </h4>
            </div>
            <div className="collapse" data-parent="#accordion" id="filterCollapse">
              <div className="ibox-content text-darkblue">  
                <strong>Araç No</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterId: event.target.value.replace(/\D+/g, '')})} onKeyDown={this.handleKeyPress} placeholder="Araç No" type="text" value={this.state.filterId}/>
                <strong>Araç Başlığı</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterTitle: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Araç Başlığı" type="text" value={this.state.filterTitle}/>
                <strong>Marka</strong>
                <Select
                  className="form-input mb-2 mt-1 text-dark"
                  onChange={this.selectedBrandOnChange}
                  options={selectedBrandsOptions}
                  isClearable={true}
                  defaultValue={selectedBrandsOptions.find((brand) => brand.value.toString() === this.state.filterVehicleBrandId) || selectedBrandsOptions[0]}
                  placeholder="Seçiniz"
                  value={selectedBrandsOptions.find((brand) => brand.value.toString() === this.state.filterVehicleBrandId)}
                  filterOption={(option, searchText) =>
                    option.data.search &&
                    option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                  }
                />
                <strong>Model</strong>
                <Select
                  className="form-input mb-2 mt-1 text-dark"
                  isDisabled={this.state.vehicleModels.length === 0}
                  onChange={this.selectedModelOnChange}
                  options={selectedModelsOptions}
                  isClearable={true}
                  defaultValue={selectedModelsOptions.find((model) => model.value.toString() === this.state.filterVehicleModelId) || selectedModelsOptions[0]}
                  placeholder="Seçiniz"
                  value={selectedModelsOptions.find((model) => model.value.toString() === this.state.filterVehicleModelId)}
                  filterOption={(option, searchText) =>
                    option.data.search &&
                    option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                  }
                />
                <h5><strong>Araç Yılı<strong className="text-danger ml-1">*</strong></strong></h5>
                <Select
                  className="form-input mb-2 mt-1 text-dark"
                  isDisabled={this.state.vehicleModelYears.length === 0}
                  onChange={this.selectedYearOnChange}
                  options={selectedYearsOptions}
                  isClearable={true}
                  defaultValue={selectedYearsOptions.find((year) => year.value == this.state.filterYear) || selectedYearsOptions[0]}
                  placeholder="Seçiniz"
                  value={selectedYearsOptions.find((year) => year.value == this.state.filterYear)}
                  /* filterOption={(option, searchText) =>
                    option.data.search &&
                    option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                  } */
                />
                <strong>Donanım</strong>
                <Select
                  className="form-input mb-2 mt-1 text-dark"
                  isDisabled={this.state.vehicleEquipments.length === 0}
                  onChange={this.selectedVariantOnChange}
                  options={selectedVariantsOptions}
                  isClearable={true}
                  defaultValue={selectedVariantsOptions.find((variant) => variant.value.toString() === this.state.filterVehicleEquipmentId) || selectedVariantsOptions[0]}
                  placeholder="Seçiniz"
                  value={selectedVariantsOptions.find((variant) => variant.value.toString() === this.state.filterVehicleEquipmentId)}
                  filterOption={(option, searchText) =>
                    option.data.search &&
                    option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                  }
                />
                <div className="d-flex justify-content-end">
                  <button className="btn btn-orange mt-3 mr-2" onClick={this.resetOnClick}><i className="fa fa-refresh"></i> Sıfırla</button>
                  <button className="btn btn-orange mt-3" onClick={this.filterOnClick}><i className="fa fa-filter"></i> Filtrele</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 order-first order-xl-last d-none d-xl-block">
          <div className="ibox">
            <div className="ibox-title text-darkblue">
              <h5><i className="fa fa-filter"></i> Filtrele</h5>
            </div>
            <div className="ibox-content text-darkblue">
              <strong>Araç No</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterId: event.target.value.replace(/\D+/g, '')})} onKeyDown={this.handleKeyPress} placeholder="Araç No" type="text" value={this.state.filterId}/>
              <strong>Araç Başlığı</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterTitle: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Araç Başlığı" type="text" value={this.state.filterTitle}/>
              <strong>Marka</strong>
              <Select
                className="form-input mb-2 mt-1 text-dark"
                onChange={this.selectedBrandOnChange}
                options={selectedBrandsOptions}
                isClearable={true}
                defaultValue={selectedBrandsOptions.find((brand) => brand.value.toString() === this.state.filterVehicleBrandId) || selectedBrandsOptions[0]}
                placeholder="Seçiniz"
                value={selectedBrandsOptions.find((brand) => brand.value.toString() === this.state.filterVehicleBrandId)}
                filterOption={(option, searchText) =>
                  option.data.search &&
                  option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                }
              />
              <strong>Model</strong>
              <Select
                className="form-input mb-2 mt-1 text-dark"
                isDisabled={this.state.vehicleModels.length === 0}
                onChange={this.selectedModelOnChange}
                options={selectedModelsOptions}
                isClearable={true}
                defaultValue={selectedModelsOptions.find((model) => model.value.toString() === this.state.filterVehicleModelId) || selectedModelsOptions[0]}
                placeholder="Seçiniz"
                value={selectedModelsOptions.find((model) => model.value.toString() === this.state.filterVehicleModelId)}
                filterOption={(option, searchText) =>
                  option.data.search &&
                  option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                }
              />
              <h5><strong>Araç Yılı<strong className="text-danger ml-1">*</strong></strong></h5>
              <Select
                className="form-input mb-2 mt-1 text-dark"
                isDisabled={this.state.vehicleModelYears.length === 0}
                onChange={this.selectedYearOnChange}
                options={selectedYearsOptions}
                isClearable={true}
                defaultValue={selectedYearsOptions.find((year) => year.value == this.state.filterYear) || selectedYearsOptions[0]}
                placeholder="Seçiniz"
                value={selectedYearsOptions.find((year) => year.value == this.state.filterYear)}
                /* filterOption={(option, searchText) =>
                  option.data.search &&
                  option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                } */
              />
              <strong>Donanım</strong>
              <Select
                className="form-input mb-2 mt-1 text-dark"
                isDisabled={this.state.vehicleEquipments.length === 0}
                onChange={this.selectedVariantOnChange}
                options={selectedVariantsOptions}
                isClearable={true}
                defaultValue={selectedVariantsOptions.find((variant) => variant.value.toString() === this.state.filterVehicleEquipmentId) || selectedVariantsOptions[0]}
                placeholder="Seçiniz"
                value={selectedVariantsOptions.find((variant) => variant.value.toString() === this.state.filterVehicleEquipmentId)}
                filterOption={(option, searchText) =>
                  option.data.search &&
                  option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                }
              />
              <div className="d-flex justify-content-end">
                <button className="btn btn-orange mt-3 mr-2" onClick={this.resetOnClick}><i className="fa fa-refresh"></i> Sıfırla</button>
                <button className="btn btn-orange mt-3" onClick={this.filterOnClick}><i className="fa fa-filter"></i> Filtrele</button>
              </div>
            </div>
            <AuctionCommentModal comment={this.state.comment} isOpen={this.state.isOpenCommentModal} modalTitle="Araç Açıklaması" onRequestClose={() => this.setState({isOpenCommentModal: false})} />
          </div>
        </div>
      </div>
    );
  }
}

export default function AuctionVehicles(props) {
  return (
    <AuctionVehiclesModule navigate={useNavigate()} searchParams={useSearchParams()[0]}></AuctionVehiclesModule>
  );
}
